import { initLoginForm} from "./utils";
import { addFormatting, getNumberFormat } from "../functions/utils";
import { pendingFormats } from "../functions/shared-state";

Office.onReady(async () => {
    initLoginForm();
    const refreshBtn = document.getElementById("refresh-button");
    if (refreshBtn) {
      refreshBtn.onclick = run;
    }
    setInterval(async () => {
        if (pendingFormats.size === 0) return;

        const entries = Array.from(pendingFormats.entries());
        pendingFormats.clear();

        for (const [cellAddress, data] of entries) {
            await addFormatting(cellAddress, data);
        }
    }, 1000);
});


export async function run() {
  try {
    await Excel.run(async (context) => {
      console.log("Starting refresh...");

      await OfficeRuntime.storage.setItem("refresh_flag", "true");

      context.workbook.application.calculate(Excel.CalculationType.full);

      await context.sync();
      console.log("Refresh complete : cache vidé et calcul relancé");
    });
  } catch (error) {
    console.error("Error during refresh:", error);
  }
}